module.exports = __webpack_public_path__ + "img/zhitongche.776a5392.png";